module.exports = __webpack_public_path__ + "img/Beta Digitis - Gif 2_2-61.3f61ad93.png";